import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Severity } from 'graphql-api/baskets-api-interfaces';

import { alertStates } from './alert-state';

@Component({
  selector: 'atx-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlertComponent implements OnChanges, OnInit {
  @Input() public severity: Severity = Severity.Warning;

  @Input() public icon: IconDefinition | null = null;

  private alertClass: string;

  public iconClass = 'text-warning';

  @HostBinding('class') get hostClass() {
    return `d-flex alert ${this.alertClass}`;
  }

  public ngOnInit() {
    this.selectIcon();
    this.selectClasses();
  }

  public ngOnChanges({ icon, severity }: SimpleChanges) {
    if (icon?.currentValue) {
      this.selectIcon();
    }

    if (severity?.currentValue) {
      this.selectClasses();
    }
  }

  private selectIcon() {
    if (!this.icon) {
      const state = alertStates[this.severity];
      this.icon = state.icon;
    }
  }

  private selectClasses() {
    const state = alertStates[this.severity];
    this.alertClass = state.alertClass;
    this.iconClass = state.textClass;
  }
}
